const debug = require('debug')('util:clock');

// The clock singleton. useGameUpdate owns the interval and attaches its controls here so
// that non-React code (actions, controllers) can pause or reset time without a hook.
let paused = false;
let handle = null;

const clock = {
  attach: controls => {
    handle = controls;
  },
  detach: () => {
    handle = null;
  },

  // Discard progress toward the current phase. Call this after an action burns a phase, so
  // the player doesn't get a clock tick immediately afterwards.
  reset: () => handle?.reset(),

  // Restart only the ambient line interval, leaving progress toward the phase alone. Call
  // this after the player's own action writes to the log, so the road doesn't speak on top
  // of them.
  resetAmbient: () => handle?.resetAmbient(),

  inspect: () => handle?.inspect(),

  // Force phases through regardless of the gate. Debug only.
  advance: (n = 1) => handle?.advance(n),

  pause: () => {
    debug('pausing');
    paused = true;
  },
  resume: () => {
    debug('resuming');
    paused = false;
    clock.reset();
  },
  toggle: () => (paused ? clock.resume() : clock.pause()),

  isPaused: () => paused,
  isRunning: () => !paused && !!handle
};

export default clock;
